import React from 'react';
import {useEffect, useState} from 'react';
import FederalComponent from '../../join-commute/payment-screen/federal-component/FederalComponent';

export default function FederalOrCommuterRadio(props) {
    const [isFederal, updateIsFederal] = useState(props.isFederal);
    const [isCommuter, updateIsCommuter] = useState(props.isCommuter);

  function handleOptionClick(option) {
        updateIsFederal(option == 'isFederal');
        updateIsCommuter(option == 'isCommuter');
        props.updateIsFederal(option == 'isFederal');
        props.updateIsCommuter(option == 'isCommuter');
        props.onUpdateAuthorizedAmount();
  }

  function handleOptionKeyDown(e, option) {
    if (e.key === 'Enter' || e.key === ' ') {
      handleOptionClick(option);
    }
  }

  return (
    <div className={`checkFederalCommute ${props.isCvvZipValid ? 'zip-cvv-invalid' : ''}`} role="radiogroup" aria-labelledby='checkFederalCommute'>
    <label  tabIndex={0} className='checkFederalCommuteLabel' id='checkFederalCommute'>What type of card are you using?*</label>
    <div className='radio-section'>
      <div
        tabIndex={0}
        role='radio'
        aria-checked={isFederal === true}
        onClick={() => handleOptionClick('isFederal')}
        onKeyDown={(e) => handleOptionKeyDown(e, 'isFederal')}
        className={isFederal === true ? 'radio active' : 'radio'}
        aria-labelledby='isFederal'
      >
        <div className='round'></div>
        <label id="isFederal" className='text'>Federal Benefit Card</label>
      </div>

      {
        isFederal && 
        <FederalComponent
        authorizedAmount={props.authorizedAmount}
        onUpdateAuthorizedAmount={props.onUpdateAuthorizedAmount}
        updateIsAmountValid={props.updateIsAmountValid}
        maxAmount={props.maxAmount}
        isAmountValid={props.isAmountValid}
        isCommuter={false} />
      }
      <div
        tabIndex={0}
        role='radio'
        aria-checked={isCommuter === true}
        onClick={() => handleOptionClick('isCommuter')}
        onKeyDown={(e) => handleOptionKeyDown(e, 'isCommuter')}
        className={isCommuter === true ? 'radio active' : 'radio'}
        aria-labelledby='isCommuter'
      >
        <div className='round'></div>
        <label id="isCommuter" className='text'>Commuter Benefit Card</label>
      </div>
      {
              isCommuter && 
              <FederalComponent
              authorizedAmount={props.authorizedAmount}
              onUpdateAuthorizedAmount={props.onUpdateAuthorizedAmount}
              updateIsAmountValid={props.updateIsAmountValid}
              maxAmount={props.maxAmount}
              isAmountValid={props.isAmountValid}
              isCommuter={isCommuter} />
      }
    </div>
  </div>
  );
}